import dictionary from "./translations.json";

export const getTranslation = (text) => {

  try {
    const lang = localStorage.getItem("lang");
    const entry = dictionary[text];
    if (!entry || entry[lang] == null) {
      return text;
    }

    return entry[lang] || text;
  } catch (error) {
    return text;
  }
};